import React from "react";
import './Track.css';

function Track(props) {

    return (
        <div className="track-element">
            <h4>{props.name}</h4>
            <p>{props.artist} - {props.album}</p>
        </div>
    );
}

export default Track;
